<template>
  <div class="stages-icons" id="stages-icons" v-scroll="onScroll" :style="{width: stageSize + 'px', backgroundColor: bodyColor}">
    <div class="common-info-wrap" id="common-info-wrap" :style="{width: this.commonInfoWrapWidth + 'px'}" v-show="openText">
      <div class="common-info">
        <h4>{{ openText }}</h4>
      </div>
    </div>
    <el-container class="stage-icon" v-for="stage in stages" :key="stage" v-if="stage.preview">
      <el-header :height="headerHeight">
        <div v-if="stage.stage_icon">
          <div class="stage-label-image">
            <img :src="stage.stage_icon" alt="">
          </div>
        </div>
        <div v-else>
          <div class="label" :style="{border: '1px solid ' + stage.artist_color, color: '#fff', backgroundColor: stage.artist_color}">
            <div>
              <h3 class="first_name" :style="{color: stage.background_color}">{{stage.first_name}}</h3>
              <h3 class="second_name" :style="{color: 'white'}">{{stage.second_name}}</h3>
              <h3 class="third_name" :style="{color: stage.background_color}">{{stage.third_name}}</h3>
            </div>
          </div>
        </div>
      </el-header>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'Stage',
  props: {
    headerHeight: {
      default: 150 + 'px'
    },
    stages: {
      type: Array,
      required: true
    },
    startHours: '',
    endHours: '',
    openText: '',
    bodyColor: '',
    scrollLeft: ''
  },
  watch: {
    startHours: function (val) {
      this.startHours = val
    },
    endHours: function (val) {
      this.endHours = val
      this.setHeight()
    },
    scrollLeft: function () {
      this.updateScroll()
    }
  },
  data () {
    return {
      artistInfo: '',
      styleContainerHeight: 0, // el-header + el-mainの高さの合計値
      styleMainHeight: 0, // el-mainの高さ(実質の開催時間 * 144の数値)
      styleHeaderHeight: 150,
      fullScreenLoading: false,
      headerSize: 0,
      commonInfoWrapWidth: 160,
      stageSize: 0
    }
  },
  beforeMount () {
    this.setHeight()
  },
  mounted () {
    this.openDoorWidth()
  },
  methods: {
    setHeight () {
      // this.styleHeaderHeightを追加することで、this.styleContainerHeightはheaderとel-mainの高さを含んだものになる
      const performanceTime = Math.abs(this.endHours - this.startHours) // マイナスになる可能性があるので、絶対値として処理
      this.styleMainHeight = (performanceTime * 144) // 144px = 12px/分 * (60分/5分 = 12) = 1時間| 5分単位でタイムテーブルを作成している。144pxに実施時間を掛けた内容
      this.styleContainerHeight = (performanceTime * 144) + this.styleHeaderHeight // 144px = 12px/分 * (60分/5分 = 12) = 1時間| 5分単位でタイムテーブルを作成している。el-header + el-mainの合計値
    },
    openDoorWidth () {
      const stage = document.getElementsByClassName('stage-icon')
      const stageWidth = stage[0].clientWidth
      this.commonInfoWrapWidth = stageWidth * stage.length - 1
    },
    stageWidth () {
      const stage = document.getElementsByClassName('stages')
      this.stageSize = stage[0].clientWidth
    },
    onScroll: function (e, position) {
      this.$parent.scrollLeft = position.scrollLeft
    },
    updateScroll () {
      document.getElementById('stages-icons').scrollTo(this.scrollLeft, 0)
    }
  },
  updated () {
    window.addEventListener('resize', this.openDoorWidth, false) // ウィンドウサイズ変更時に呼び出す
    this.openDoorWidth()
    window.addEventListener('resize', this.stageWidth, false) // ウィンドウサイズ変更時に呼び出す
    this.stageWidth()
  }
}
</script>

<style lang="scss">
  @import "../../assets/css/components/parts/StageIcon";
</style>



// WEBPACK FOOTER //
// src/components/parts/StageIcons.vue